<div>
  <h1 data-automation-name="home">Venway Console</h1>
  <div class="home-div">
    <div class="col-lg-6" style="padding: 3px">
      <div id="ven-panel" class="panel panel-default">
        <div class="panel-heading">VENs</div>
        <app-ven-index [isComponentImported]="true" [elementsPerPage]="8"></app-ven-index>
      </div>
    </div>
    <div class="col-lg-6" style="padding: 3px">
      <div id="event-panel" class="panel panel-default">
        <div class="panel-heading">Events</div>
        <app-event-index [isComponentImported]="true" [elementsPerPage]="8"></app-event-index>
      </div>
    </div>
  </div>
</div>
